const DIR_COLORS = {
  BUY: { fill: "rgba(34,197,94,0.15)", stroke: "rgba(34,197,94,0.5)", text: "#22c55e" },
  SELL: { fill: "rgba(239,68,68,0.15)", stroke: "rgba(239,68,68,0.5)", text: "#ef4444" },
  WAIT: { fill: "rgba(234,179,8,0.15)", stroke: "rgba(234,179,8,0.5)", text: "#eab308" },
};

function roundRect(ctx, x, y, w, h, r) {
  ctx.beginPath();
  ctx.moveTo(x + r, y);
  ctx.arcTo(x + w, y, x + w, y + h, r);
  ctx.arcTo(x + w, y + h, x, y + h, r);
  ctx.arcTo(x, y + h, x, y, r);
  ctx.arcTo(x, y, x + w, y, r);
  ctx.closePath();
}

function wrapText(ctx, text, maxWidth, maxLines) {
  const words = (text || "").split(" ");
  const lines = [];
  let line = "";
  for (const w of words) {
    const test = line ? `${line} ${w}` : w;
    if (ctx.measureText(test).width > maxWidth && line) {
      lines.push(line);
      line = w;
      if (lines.length === maxLines - 1) break;
    } else {
      line = test;
    }
  }
  if (line && lines.length < maxLines) lines.push(line);
  if (lines.length === maxLines && words.join(" ").length > lines.join(" ").length) {
    lines[maxLines - 1] = lines[maxLines - 1].replace(/\s+\S*$/, "") + "…";
  }
  return lines;
}

function priceRow(ctx, label, value, y, color, W) {
  ctx.textAlign = "left";
  ctx.font = "600 26px 'JetBrains Mono', monospace";
  ctx.fillStyle = "#71717a";
  ctx.fillText(label.toUpperCase(), 110, y);
  ctx.textAlign = "right";
  ctx.font = "700 34px 'JetBrains Mono', monospace";
  ctx.fillStyle = color;
  ctx.fillText(value !== undefined && value !== null && value !== 0 ? String(value) : "—", W - 110, y);
  ctx.strokeStyle = "rgba(39,39,42,0.9)";
  ctx.lineWidth = 1;
  ctx.beginPath();
  ctx.moveTo(110, y + 22);
  ctx.lineTo(W - 110, y + 22);
  ctx.stroke();
}

const loadLogo = () => new Promise((resolve) => {
  const img = new Image();
  img.onload = () => resolve(img);
  img.onerror = () => resolve(null);
  img.src = "/icons/icon-192.png";
});

async function drawLogo(ctx, x, y, size) {
  const logo = await loadLogo();
  if (logo) {
    ctx.save();
    roundRect(ctx, x, y, size, size, 12);
    ctx.clip();
    ctx.drawImage(logo, x, y, size, size);
    ctx.restore();
  } else {
    ctx.fillStyle = "#d4a017";
    roundRect(ctx, x, y, size, size, 12);
    ctx.fill();
  }
}

export async function renderAnalysisImage(r, lang = "cs") {
  const W = 1080, H = 1350;
  const canvas = document.createElement("canvas");
  canvas.width = W;
  canvas.height = H;
  const ctx = canvas.getContext("2d");

  // Background
  ctx.fillStyle = "#09090b";
  ctx.fillRect(0, 0, W, H);
  ctx.strokeStyle = "rgba(24,24,27,0.9)";
  ctx.lineWidth = 1;
  for (let x = 0; x <= W; x += 72) { ctx.beginPath(); ctx.moveTo(x, 0); ctx.lineTo(x, H); ctx.stroke(); }
  for (let y = 0; y <= H; y += 72) { ctx.beginPath(); ctx.moveTo(0, y); ctx.lineTo(W, y); ctx.stroke(); }

  // Top accent bar
  ctx.fillStyle = "#d4a017";
  ctx.fillRect(0, 0, W, 10);

  // Header — logo + brand
  await drawLogo(ctx, 70, 60, 64);
  ctx.textAlign = "center";
  ctx.textBaseline = "middle";
  ctx.textAlign = "left";
  ctx.font = "700 44px 'Outfit', Arial, sans-serif";
  ctx.fillStyle = "#fafafa";
  ctx.fillText("TradeMind", 155, 92);
  const tmWidth = ctx.measureText("TradeMind ").width;
  ctx.fillStyle = "#e3b341";
  ctx.fillText("AI", 155 + tmWidth, 92);
  ctx.font = "500 22px 'JetBrains Mono', monospace";
  ctx.fillStyle = "#71717a";
  ctx.textAlign = "right";
  ctx.fillText(lang === "cs" ? "AI ANALÝZA GRAFU" : "AI CHART ANALYSIS", W - 70, 92);

  // Instrument + timeframe
  ctx.textAlign = "left";
  ctx.font = "700 84px 'JetBrains Mono', monospace";
  ctx.fillStyle = "#fafafa";
  ctx.fillText(r.instrument || "—", 70, 240);
  const instWidth = ctx.measureText(r.instrument || "—").width;
  ctx.strokeStyle = "rgba(63,63,70,0.9)";
  ctx.lineWidth = 2;
  roundRect(ctx, 70 + instWidth + 28, 205, 120, 52, 8);
  ctx.stroke();
  ctx.font = "600 28px 'JetBrains Mono', monospace";
  ctx.fillStyle = "#a1a1aa";
  ctx.textAlign = "center";
  ctx.fillText(r.timeframe || "—", 70 + instWidth + 88, 233);

  // Direction pill
  const dir = r.direction || "WAIT";
  const dc = DIR_COLORS[dir] || DIR_COLORS.WAIT;
  ctx.fillStyle = dc.fill;
  roundRect(ctx, 70, 300, 280, 84, 14);
  ctx.fill();
  ctx.strokeStyle = dc.stroke;
  ctx.lineWidth = 2;
  roundRect(ctx, 70, 300, 280, 84, 14);
  ctx.stroke();
  ctx.fillStyle = dc.text;
  ctx.beginPath();
  ctx.arc(112, 342, 8, 0, Math.PI * 2);
  ctx.fill();
  ctx.font = "700 44px 'JetBrains Mono', monospace";
  ctx.textAlign = "left";
  ctx.fillText(dir, 138, 345);

  // Grade box
  const grade = r.setup_grade || "C";
  ctx.fillStyle = "rgba(34,197,94,0.12)";
  roundRect(ctx, 380, 300, 110, 84, 14);
  ctx.fill();
  ctx.strokeStyle = "rgba(34,197,94,0.4)";
  roundRect(ctx, 380, 300, 110, 84, 14);
  ctx.stroke();
  ctx.fillStyle = "#22c55e";
  ctx.font = "700 46px 'JetBrains Mono', monospace";
  ctx.textAlign = "center";
  ctx.fillText(grade, 435, 345);

  // Confidence + RR
  ctx.textAlign = "left";
  ctx.font = "500 22px 'JetBrains Mono', monospace";
  ctx.fillStyle = "#71717a";
  ctx.fillText(lang === "cs" ? "DŮVĚRA" : "CONFIDENCE", 540, 320);
  ctx.font = "700 44px 'JetBrains Mono', monospace";
  ctx.fillStyle = "#fafafa";
  ctx.fillText(`${r.confidence || 0}%`, 540, 368);
  ctx.font = "500 22px 'JetBrains Mono', monospace";
  ctx.fillStyle = "#71717a";
  ctx.fillText("R:R", 800, 320);
  ctx.font = "700 44px 'JetBrains Mono', monospace";
  ctx.fillStyle = "#fafafa";
  ctx.fillText(`1:${r.risk_reward || "—"}`, 800, 368);

  // Price levels card
  ctx.fillStyle = "rgba(24,24,27,0.75)";
  roundRect(ctx, 70, 440, W - 140, 470, 18);
  ctx.fill();
  ctx.strokeStyle = "rgba(39,39,42,1)";
  roundRect(ctx, 70, 440, W - 140, 470, 18);
  ctx.stroke();
  ctx.font = "600 24px 'JetBrains Mono', monospace";
  ctx.fillStyle = "#71717a";
  ctx.textAlign = "left";
  ctx.fillText(lang === "cs" ? "CENOVÉ ÚROVNĚ" : "PRICE LEVELS", 110, 500);
  priceRow(ctx, "Entry", r.entry, 575, "#fafafa", W);
  priceRow(ctx, "Stop Loss", r.stop_loss, 650, "#f87171", W);
  priceRow(ctx, "TP 1", r.take_profit_1, 725, "#4ade80", W);
  priceRow(ctx, "TP 2", r.take_profit_2, 800, "#4ade80", W);
  priceRow(ctx, "TP 3", r.take_profit_3, 875, "#4ade80", W);

  // Reasoning
  ctx.font = "400 28px Arial, sans-serif";
  ctx.fillStyle = "#d4d4d8";
  const lines = wrapText(ctx, r.reasoning || "", W - 140, 4);
  lines.forEach((line, i) => ctx.fillText(line, 70, 985 + i * 42));

  // Footer
  ctx.strokeStyle = "rgba(39,39,42,1)";
  ctx.beginPath();
  ctx.moveTo(70, 1200);
  ctx.lineTo(W - 70, 1200);
  ctx.stroke();
  ctx.font = "700 30px 'Outfit', Arial, sans-serif";
  ctx.fillStyle = "#e3b341";
  ctx.fillText("trademind.ai", 70, 1252);
  ctx.font = "400 20px Arial, sans-serif";
  ctx.fillStyle = "#52525b";
  ctx.fillText(
    lang === "cs" ? "Nejedná se o investiční doporučení. Obchodování nese riziko ztráty." : "Not financial advice. Trading carries risk of loss.",
    70, 1295
  );
  ctx.textAlign = "right";
  ctx.font = "500 20px 'JetBrains Mono', monospace";
  ctx.fillStyle = "#71717a";
  ctx.fillText(new Date().toLocaleDateString(lang === "cs" ? "cs-CZ" : "en-US"), W - 70, 1252);

  return canvas;
}

export async function shareAnalysis(r, lang = "cs") {
  const canvas = await renderAnalysisImage(r, lang);
  const blob = await new Promise((resolve) => canvas.toBlob(resolve, "image/png"));
  const fileName = `trademind-${(r.instrument || "analysis").toLowerCase().replace(/[^a-z0-9]/g, "")}.png`;
  const file = new File([blob], fileName, { type: "image/png" });
  const shareText = lang === "cs"
    ? `AI analýza ${r.instrument || ""}: ${r.direction || "WAIT"} (${r.confidence || 0}% důvěra) — TradeMind AI`
    : `AI analysis ${r.instrument || ""}: ${r.direction || "WAIT"} (${r.confidence || 0}% confidence) — TradeMind AI`;
  if (navigator.canShare && navigator.canShare({ files: [file] })) {
    await navigator.share({ files: [file], title: "TradeMind AI", text: shareText });
    return "shared";
  }
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = fileName;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
  return "downloaded";
}
